import * as React from 'react';
import { Provider } from 'react-redux';
import { HashRouter, Route } from 'react-router-dom';
import Chrome from '@vcd-ecm-ui/chrome';
import LoadExternalSVG from '@vcd-ecm-ui/LoadExternalSVG/src';
import Content from '../Content/Content';
import Header from '../Header/Header';
import LeftNav from '../LeftNav/LeftNav';
import store from '../../store/store';
import useLoginGatekeeper from '../../hooks/useLoginGatekeeper';
import { LOCAL_STORAGE_AUTH_IDP_ITEM } from '../../shared-types/auth/AuthUrlFactory';

const App = (): JSX.Element => {
  const [isLoggedIn, , authUrls] = useLoginGatekeeper();

  // @TODO: create and use loading component
  if (!isLoggedIn) {
    return null;
  }

  // make sure the IdP has not changed, and if it has, force a logout
  if (authUrls.idpHasChanged()) {
    authUrls.logoutFunction();
    return null;
  }
  localStorage.setItem(LOCAL_STORAGE_AUTH_IDP_ITEM, authUrls.getIdP());

  return (
    <Provider store={store}>
      <LoadExternalSVG url="/images/sprite-ui.svg" />
      <HashRouter>
        <Route path="*">
          <Chrome Header={Header} Nav={LeftNav} Content={Content} />
        </Route>
      </HashRouter>
    </Provider>
  );
};

export default App;
